export const API_PATH_ApiDeviceMgmtDeviceCreate = '/services/devices-mgtm/apiDeviceMgmtDeviceCreate';
